module.exports = __webpack_public_path__ + "family_modern-vibrant_1.jpg";